import { InputText } from '@/components/form';
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover';
import Icons from '@/const/icons';
import React from 'react';
import { useForm } from 'react-hook-form';
import NavbarSearchMenu from './NavbarSearchMenu';
import useDeviceWidth from '@/hooks/useDeviceWidth';
import clsx from 'clsx';
import { dashboardApplicationsService } from '@/api/dashboardApplication';
import { GET_DASHBOARD_SEARCH_RESULTS } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';

// Constants for initial data

const NavbarSearch = () => {
	const width = useDeviceWidth();
	const { register } = useForm();
	const [isOpen, setIsOpen] = React.useState<boolean>(false);
	const [searchTerm, setSearchTerm] = React.useState<string>('');

	const [searchFilter] = useDebounce(searchTerm, 500);
	const { data: searchData, isFetching } = useQuery({
		queryKey: [GET_DASHBOARD_SEARCH_RESULTS, searchFilter],
		queryFn: () =>
			dashboardApplicationsService.getClientAndCasesList(searchFilter),
		refetchOnWindowFocus: false,
	});

	const handleSearch = (search: string) => {
		setSearchTerm(search);
	};

	return (
		<Popover
			open={isOpen}
			onOpenChange={(open) => {
				if (!open || searchTerm.trim() === '') {
					setIsOpen(false);
				} else {
					setIsOpen(true);
				}
			}}
		>
			<PopoverTrigger asChild>
				<div className="w-full">
					<InputText
						name="search"
						register={register}
						placeholder="Search"
						iconLeft={Icons.search}
						classNameIcon={'!top-[27%] !w-4 !h-4 text-opacity-black'}
						classNameInput={clsx(
							'pl-11 !w-[408px] !h-8 !bg-gray-15 !rounded-[100px] !m-0 border-none 3xl:!text-sm'
						)}
						onChange={({ target }) => {
							if (target.value.trim() === '') {
								setIsOpen(false);
							} else {
								setIsOpen(true);
							}
							handleSearch(target.value);
						}}
					/>
				</div>
			</PopoverTrigger>
			<PopoverContent
				onOpenAutoFocus={(e) => e.preventDefault()}
				style={{ width: width > 1020 ? '417px' : width }}
				className={clsx(
					' !p-6 mt-4 bg-white',
					width > 1020
						? '!rounded-3xl'
						: '!rounded-none !h-[700px] !shadow-none !border-none'
				)}
			>
				<NavbarSearchMenu
					searchData={searchData?.data}
					search={searchTerm}
					isFetching={isFetching}
					setIsOpen={setIsOpen}
				/>
			</PopoverContent>
		</Popover>
	);
};

export default NavbarSearch;
